const t = "{{currentTime}} / {{duration}}", A = "検索結果{{current}} / {{total}}", n = "結果が見つかりませんでした", o = "{{count}}件の検索結果", E = "{{count}}件の検索結果", c = '$t(HOURS, { "count": {{hours}} })、$t(MINUTES, { "count": {{minutes}} }) と$t(SECONDS, { "count": {{seconds}} })からプレイ開始。', T = '$t(MINUTES, { "count": {{minutes}} }) と$t(SECONDS, { "count": {{seconds}} })からプレイ開始。', _ = '$t(SECONDS, { "count": {{seconds}} })からプレイ開始。', s = "トランスクリプトを変更を保存中にエラーが発生しました。", S = "トランスクリプトの行は{{time}}。コンテンツは：{{text}}。", N = 'トランスクリプトの行のコンテナ。このコンテナ内に$t(TRANSCRIPT_LINES, { "count": {{count}} })。このコンテナ内を移動するには、下矢印キーを使用します。', R = "変更を保存中...", O = "変更がトランスクリプトに保存されました。", I = "「キャプションを更新」ボタンが利用可能になりました。", C = "処理", P = "{{time}}に注釈を追加する", U = "質問を{{time}}に追加する", L = "注釈", D = "自動", e = "自動 ({{quality}})", M = "戻る", u = "キャプション", G = "キャプションの言語", Y = "キャプションの管理", H = "{{language}}を消去する", r = "フォントサイズ:", V = "キャプションの言語：{{language}}", B = "{{language}}（自動）", a = "検索をクリアする", i = "閉じる", K = "コメント", m = "続行する", F = "再生速度を下げる", d = "{{percent}}%で音量を下げる", l = "下の矢印", W = "トランスクリプトエディタを閉じる", $ = "キャプションを更新", g = "エラー！", h = "保存しています…", Q = "保存されました!", J = "トランスクリプトを編集", p = "テキストは空欄にすることはできません！", x = "全画面", Z = "{{count}} 時間", X = "{{count}} 時間", f = "再生速度を上げる", j = "{{percent}}%で音量を上げる", q = "色を反転する", v = "特定のパーセンテージ（1-10%、2-20%など）にジャンプする", y = "スタート位置へジャンプ", b = "{{title}}のためのアクション", k = "キーボード ショートカット", w = "言語", z = "左の矢印", tt = "メインメニュー", At = "{{count}} 分", nt = "{{count}} 分", ot = "消音", Et = "ミュートになっています", ct = "次のキャプションの言語", Tt = "次の検索結果", _t = "オフ", st = "上", St = "注釈を{{time}}で開く", Nt = "完了した小テストを{{time}}で開く", Rt = "小テストを{{time}}で開く", Ot = "一時停止", It = "再生", Ct = "再生速度", Pt = "再生速度：{{speed}}x", Ut = "前のキャプションの言語", Lt = "前の検索結果", Dt = "質", et = "質のメニュー", Mt = "再度再生", ut = "再生速度をリセット", Gt = "右の矢印", Yt = "トランスクリプト内で検索", Ht = "{{count}} 秒", rt = "{{count}} 秒", Vt = "巻き戻し:{{seconds}}秒", Bt = "早送り:{{seconds}}秒", at = "設定", it = "ショートカット", Kt = "メディアの詳細とツール", mt = "スペース", Ft = "再生速度メニュー", dt = "自動スクロールを開始", lt = "キャプションの切り替え", Wt = "ミュートの切り替え", $t = "再生/一時停止の切り替え", gt = "{{count}}のトランスクリプト行", ht = "{{count}}のトランスクリプト行", Qt = "トランスクリプトを読み込み中...", Jt = "トランスクリプトを読み込めませんでした。", pt = "トランスクリプトのオプション", xt = "再試行", Zt = "トランスクリプトが利用できません", Xt = "上矢印", ft = "動画設定", jt = "音量", qt = "音量：{{volume}}%", vt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: a,
  CLOSE: i,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: W,
  EDIT_CONFIRM: $,
  EDIT_ERROR: g,
  EDIT_SAVING: h,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: j,
  INVERT_COLORS: q,
  JUMP_TO_PERCENTAGE: v,
  JUMP_TO_START: y,
  KEBAB_MENU: b,
  KEYBOARD_SHORTCUTS: k,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: at,
  SHORTCUT: it,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: Wt,
  TOGGLE_PLAY_PAUSE: $t,
  TRANSCRIPT_LINES: gt,
  TRANSCRIPT_LINES_other: ht,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: jt,
  VOLUME_VALUE: qt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  a as CLEAR_SEARCH,
  i as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  W as EDIT_CLOSE,
  $ as EDIT_CONFIRM,
  g as EDIT_ERROR,
  h as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  j as INCREASE_VOLUME,
  q as INVERT_COLORS,
  v as JUMP_TO_PERCENTAGE,
  y as JUMP_TO_START,
  b as KEBAB_MENU,
  k as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  at as SETTINGS,
  it as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  Wt as TOGGLE_MUTED,
  $t as TOGGLE_PLAY_PAUSE,
  gt as TRANSCRIPT_LINES,
  ht as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  jt as VOLUME,
  qt as VOLUME_VALUE,
  vt as default
};
